import React, { useEffect, useState } from "react";
import Hero from "./Hero";
import Vision from "./Vision";
import FAQ from "../../components/FAQ";
import content from "./faqQuestions";
import CTA from "../../components/CTA";
import Brands from "../../components/Brands";
import PatternDesign from "../../components/PatternDesign";
import { Helmet } from "react-helmet";
const AboutPublisher = () => {
  const [selectFaq, setSelecteFaq] = useState(null);

  const handleShowContent = (id) => {
    if (selectFaq) {
      if (selectFaq === id) {
        setSelecteFaq(null);
      } else {
        setSelecteFaq(id);
      }
    } else {
      setSelecteFaq(id);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
    <Helmet>
        <title>About Us - Real Opinion</title>
        <meta
          name="description"
          content="Monetize your app with RealOpinions.ai — a premium plug-and-play surveywall delivering high-quality surveys and daily revenue growth for publishers"
        />
        <meta
          name="keywords"
          content="Real Opinion, Survey, Survey Wall, Survey Wall App, Survey Wall App, Survey Wall App, Survey Wall App, Survey Wall App, Survey Wall App"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Real Opinion" />
        <meta
          title="Real Opinion - About Us"
          content="Monetize your app with RealOpinions.ai — a premium plug-and-play surveywall delivering high-quality surveys and daily revenue growth for publishers"
        />
        xs
      </Helmet>
    <PatternDesign page="about"/>
      <Hero />
      <Vision />
      <Brands />
      <div className="faq-main">
        <div className="angular-pattern">
          
        </div>
        <div className="angular-pattern-2">
          
        </div>
        <p className="faq-main-sub-title">Frequently Asked Questions</p>
        <h1>What Do You Need Help With?</h1>
        <div className="faq-box">
          {content.map((val, i) => (
            <FAQ
              key={i}
              showContent={selectFaq === val.id ? true : false}
              handleSelectFaq={() => handleShowContent(val.id)}
              title={val.title}
              answer={val.content}
            ></FAQ>
          ))}
        </div>
      </div>
      <CTA></CTA>
    </>
  );
};

export default AboutPublisher;
